//Handmade with love by http://esmes.fi

function vwTOpx(value) {
  var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight|| e.clientHeight|| g.clientHeight;

  var result = (x*value)/100;
  return result;
}

function vhTOpx(value) {
  var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight|| e.clientHeight|| g.clientHeight;

  var result = (y*value)/100;
  return result;
}

var App = function(options){
  'use strict';
  var a = this;

  var defaults = {
  };

  a.config = $.extend(true, {}, defaults, options);

  a.activateCarouselSlide = function($carousel, index){
    if(a.itemWidth == 0) a.refreshSizes();

    $carousel.attr('data-active-slide', index);
    //var offset = ((index - 1) * -75) + 'vw';
    var offset = ((index - 1) * -(a.itemWidth+a.itemMargin*2)) + 'px';
    var bg_width = parseInt($('.modal-bg').css('width'));

    var bg_offset = ((index - 1) * ((bg_width-a.windowWidth) / (parseInt($carousel.attr('data-slides')) -1 ))) + 'px';
//    var bg_offset = ((index - 1) * (100 / parseInt($carousel.attr('data-slides')))) + '%';
    $('.modal-bg').css('transform', 'translateX(-'+bg_offset+')');
    $carousel.find('> .carousel-items').css('transform', 'translateX('+offset+')');
    $('.carousel-items').attr('data-offset', offset);

    $carousel.find('.active').removeClass('active');
    $carousel.find('.carousel-item[data-slide-index="'+index+'"]').addClass('active');
    $('.navi.active').removeClass('active');
    $('.navi[data-slide-index="'+index+'"]').addClass('active');
  }
  a.stepCarousel = function($carousel, direction){
    var current_slide = parseInt($carousel.attr('data-active-slide'), 10);
    var slide_count = parseInt($carousel.attr('data-slides'), 10);
    var next_slide;

    if(direction){
      next_slide = current_slide + 1;
      if(next_slide > slide_count) next_slide = 1;
    } else {
      next_slide = current_slide - 1;
      if(next_slide < 1) next_slide = slide_count;
    }
    a.activateCarouselSlide($carousel, next_slide);
  }

  a.refreshSizes = function(){
    //var previousWindowWidth = a.windowWidth;
    a.windowWidth = $(window).width();
    a.windowHeight = $(window).height();

    if(a.itemWidth != 0) {
      var current_slide = parseInt($('.carousel-holder').attr('data-active-slide'), 10);
      if(isNaN(current_slide)) current_slide = 1;
      a.activateCarouselSlide($('.carousel-holder'), current_slide);
    }
    // Handle Carousel Spacer
    a.itemWidth = parseFloat($('.carousel-item').innerWidth());
    a.itemMargin = parseFloat($('.carousel-item').css('margin-left'));
    var newWidth = (a.windowWidth/2) - (a.itemWidth/2) - a.itemMargin;

    $('.carousel-arrow-left').css('left', newWidth-$('.carousel-arrow-left').innerWidth()/2);
    $('.carousel-arrow-right').css('right', newWidth-$('.carousel-arrow-right').innerWidth()/2);
    $('.vignette-right').css('width', newWidth);
    $('.vignette-left').css('width', newWidth);
    $('.carousel-spacer').css('width', newWidth);
    // ----
  };

  a.handleScroll = function(){
    var scroll = $(window).scrollTop();
    a.scroll = scroll;
  };

  a.init = function(){
    //Handle screen resize
    a.refreshSizes();
    $(window).resize(a.refreshSizes);
    //Handle scroll events
    a.handleScroll();
    $(window).scroll(a.handleScroll);

    $.each($('.carousel-holder'), function(i, el){
      var $carousel = $(el);
      $carousel.attr('data-active-slide', 1);
      $carousel.attr('data-slides', $carousel.find('.carousel-item').length);
    });


    $(document).on('click', '[role="open-carousel"]', function(e){
      e.preventDefault();
      $(window).scrollTop(0);

      if($('html').hasClass('mobile')) {
        $('.carousel-holder').css('height', a.windowWidth * 0.94 + 'px');

        if(a.windowWidth > a.windowHeight) { // landscape
          $('.carousel-holder').css('height', '60vh');
        }
      }

      $('.modal-carousel').addClass('open');

        var current_slide = 1;
        a.activateCarouselSlide($('.carousel-holder'), current_slide);

      $('body').addClass('modal--open');
      a.refreshSizes();
    });

    $(window).on("orientationchange", function(){
      if($('html').hasClass('mobile')) {
        if(window.orientation != 0) { // landscape
          $('.carousel-holder').css('height', '60vh');
        } else {
          $('.carousel-holder').css('height', a.windowWidth * 0.94 + 'px');
        }
        a.refreshSizes();
        setTimeout(function() {
          a.refreshSizes();
          var current_slide = parseInt($('.carousel-holder').attr('data-active-slide'), 10);
          a.activateCarouselSlide($('.carousel-holder'), current_slide);
        }, 250);
      }
    });


    $(document).on('click', '[role="navi-move"]', function(e){
      e.preventDefault();
      var index = $(this).data('slide-index');
      a.activateCarouselSlide($('.carousel-holder'), index);
    });

    $(document).on('click', '.active[role="open-page"]', function(e){
      e.preventDefault();
      $('.modal-carousel').removeClass('open');
      $(window).scrollTop(0);
      var index = $(this).data('slide-index');
      //var initialised = $(this).data('initialised');

      //if(!initialised) {
        var pagecontent =  $(this).data('page-content');

        $('#modal-' + index).find('.page-content').html(decodeURIComponent(pagecontent));
        $(this).data('initialised', true);
      //}

      $('#modal-' + index).addClass('open');
      $('body').addClass('modal-page--open');

      a.refreshSizes();
    });

    $(document).on('click', '[role="close-page"]', function(e){
      e.preventDefault();
      $(window).scrollTop(0);
      if($('video').length) {
        $('video').each(function(index) {
          $(this)[0].pause();
        });
      }
      $('.page-content').html('');
      $('.modal-carousel').removeClass('open');
      $('.open').removeClass('open');
      $('.modal-carousel').addClass('open');
      $('body').addClass('modal--open');
      $('body').removeClass('modal-page--open');
      a.refreshSizes();
    });


    $(document).on('click', '[role="close-carousel"]', function(e){
      e.preventDefault();
      $('.modal-carousel').removeClass('open');
      $('body').removeClass('modal--open');
    });

    $(document).on('click', '[role="step-left"]', function(e){
      e.preventDefault();
      a.stepCarousel($('.carousel-holder'));
    });


    $(document).on('click', '[role="step-right"]', function(e){
      e.preventDefault();
      a.stepCarousel($('.carousel-holder'), 'right');
    });

    $(document).keyup(function(e) {
      if (e.keyCode === 27) {
        if($('body').hasClass('modal-page--open')) {
          // close page
          $('[role="close-page"]').trigger('click');
        } else if ($('body').hasClass('modal--open')) {
          // close carousel
          $('[role="close-carousel"]').trigger('click');
        }
      }
    });
  };

  a.init();
};

var app;

$(document).ready(function(){

   if( $('html').hasClass('tablet') ){
     $('head').append($('<meta name="viewport" content="width=1024, user-scalable=no">'));
   } else if( $('html').hasClass('mobile') ){
     $('head').append($('<meta name="viewport" content="width=320, user-scalable=no">'));
   }

  app = new App();
});

function log(obj) {
  if (window.debug && typeof(console) !== 'undefined' && console.log) {
    console.log(obj);
  }
}